// CSS Modules - component class name prefix: ContentTeaserM__

<template>
  <figure :class="$style.container">
    <a :class="[{ ContentTeaserM__videoLink: isVideo }, $style.mediaLink]" :href="primaryLink" :target="primaryLinkNewWindow ? '_blank' : '_self'">
      <div
        :class="$style.image"
        :style="{backgroundImage: `url(${image})`}">
        <img :src="image" :alt="linkTitle">
      </div>
      <i v-if="isVideo" class="fab fa-youtube"></i>
    </a>
    <figcaption>
      <a :class="$style.secondaryLink" :href="secondaryLink" :target="secondaryLinkNewWindow ? '_blank' : '_self'">{{ category }}</a>
      <a :class="$style.primaryLink" :href="primaryLink" :target="primaryLinkNewWindow ? '_blank' : '_self'">
        {{ linkTitle }}
        <div>{{ text }}</div>
      </a>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: "ContentTeaserM",
  props: {
    isVideo: {
      type: Boolean,
      default: false
    },
    primaryLink: {
      type: String,
      default: ""
    },
    primaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    secondaryLink: {
      type: String,
      default: ""
    },
    secondaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    category: {
      type: String,
      default: ""
    },
    linkTitle: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module lang="scss">
@import "./ContentTeaserM.scss";
</style>
